/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as Yup from 'yup';
import ErrorBoundary from 'components/common/ErrorBoundary';
import WhatsNewForm from './whatsnewfrom';

const whatsNewValidationSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string().required('Description is required'),
  imageUrl: Yup.string().nullable(),
});

const WhatsNew = ({ toggleWhatsNew }) => {
  // Get API endpoint from environment variable
  const API_BASE_URL = process.env.REACT_APP_REST_API_ENDPOINT;

  const handleSubmit = async (values) => {
    try {
      // Prepare payload
      const payload = {
        title: values.title,
        description: values.description,
        imageUrl: values.imageUrl || '',
      };

      // Make POST request
      const response = await axios.post(
        `${API_BASE_URL}whatsnew/add`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      // Success response
      if (response.status === 200 || response.status === 201) {
        toast.success(
          response.data?.message || "What's New posted successfully!",
        );
        toggleWhatsNew();
      }
    } catch (error) {
      console.error("Error posting What's New:", error);

      if (error.response) {
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          "Failed to post What's New";
        toast.error(errorMessage);
      } else if (error.request) {
        toast.error('Network error. Please check your connection.');
      } else {
        toast.error('An unexpected error occurred');
      }
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={{
            title: '',
            description: '',
            imageUrl: '',
          }}
          enableReinitialize
          validationSchema={whatsNewValidationSchema}
          onSubmit={handleSubmit}
        >
          {(props) => (
            <WhatsNewForm {...props} toggleWhatsNew={toggleWhatsNew} />
          )}
        </Formik>
      </ErrorBoundary>
    </div>
  );
};

export default WhatsNew;
